import React, { useState } from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';

import { updateIssue } from '../../lib/utilities/index';

const AdminHelpScreen = (props) => {
  const { selected, Id, updateIssueStatus } = props;
  const [show, setShow] = useState(false);
  const [escalateReason, setEscalateReason] = useState('');
  const [escalateValid, setEscalateValid] = useState(false);
  const [showEscalateValidMsg, setShowEscalateValidMsg] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateIssueHandler = async (type) => {
    try {
      let updatedata = { ...selected };

      if (type) {
        if (type === 'Escalated') {
          updatedata.status = type;
          updatedata.escalateReason = escalateReason;
          updatedata.statusColor = 'red';
          if (escalateValid) {
            await updateIssue(updatedata, Id);
            handleClose();
            await updateIssueStatus(type);
            Swal.fire({
              text: 'Issue successfully escalated',
              icon: 'success',
              width: '80%',
              confirmButtonText: 'Okay',
            });
          } else {
            setShowEscalateValidMsg(true);
          }
        } else {
          setShowEscalateValidMsg(false);
          updatedata.statusColor = 'green';
          updatedata.status = type;

          await updateIssue(updatedata, Id);
          handleClose();

          await updateIssueStatus(type);
          Swal.fire({
            text: 'Issue successfully updated',
            icon: 'success',
            width: '80%',
            confirmButtonText: 'Okay',
          });
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        text: 'Update issue status error',
        icon: 'error',
        width: '80%',
        confirmButtonText: 'Okay',
      });
    }
  };

  const setCommentMessageHandler = (value) => {
    setEscalateValid(true);
    setEscalateReason(value.target.value);
  };

  return (
    <Container>
      <Row style={{ width: '100%', float: 'left' }}>
        <Col xs={12}>
          <InputHeading>User Issue Logged</InputHeading>
        </Col>

        <Col xs={12}>
          <StatusBanner style={{ background: `${selected.statusColor}` }}>
            {selected.status ? selected.status : 'Pending'}
          </StatusBanner>
        </Col>
        <Col xs={6}>
          <InputHeading style={{ marginTop: '1rem', textAlign: 'left' }}>
            Email:
          </InputHeading>
        </Col>
        <Col xs={6}>
          <InputHeadingR style={{ marginTop: '1rem', textAlign: 'left' }}>
            {selected.email ? selected.email : ''}
          </InputHeadingR>
        </Col>

        <Col xs={6}>
          <InputHeading style={{ marginTop: '1rem', textAlign: 'left' }}>
            Mobile Number:
          </InputHeading>
        </Col>
        <Col xs={6}>
          <InputHeadingR style={{ marginTop: '1rem', textAlign: 'left' }}>
            {selected.mobile ? selected.mobile : ''}
          </InputHeadingR>
        </Col>

        <Col xs={12}>
          <InputHeading
            style={{ marginTop: '2rem', textAlign: 'center', paddingLeft: 0 }}
          >
            Screenshots
          </InputHeading>
        </Col>

        {Array.isArray(selected.uploads) ? (
          selected.uploads.map((info, index) => (
            <Col xs={4} key={index}>
              <ScreenshotAttached
                style={{
                  marginTop: '1rem',
                  textAlign: 'center',
                  paddingRight: 0,
                  backgroundImage: `url(${info})`,
                }}
              />
            </Col>
          ))
        ) : (
          <Col xs={12}>
            <InputHeadingR
              style={{
                marginTop: '1rem',
                textAlign: 'center',
                paddingRight: 0,
              }}
            >
              N/A
            </InputHeadingR>
          </Col>
        )}

        <Col xs={12}>
          <InputHeading
            style={{ marginTop: '2rem', textAlign: 'center', paddingLeft: 0 }}
          >
            Comments
          </InputHeading>
        </Col>
        <Col xs={12}>
          <InputHeadingR
            style={{ marginTop: '1rem', textAlign: 'center', paddingRight: 0 }}
          >
            {selected.comment ? selected.comment : ''}
          </InputHeadingR>
        </Col>

        {/* //Disable escalate and resolve buttons as the end point has been disabled for now
        <Col xs={6}>
          <SubmitIssueButton
            style={{ background: '#D01E2D' }}
            onClick={handleShow}
          >
            Escalate
          </SubmitIssueButton>
        </Col>
        <Col xs={6}>
          <SubmitIssueButton
            onClick={updateIssueHandler.bind(this, 'Resolved')}
          >
            Resolve
          </SubmitIssueButton>
        </Col> */}
      </Row>
      <Modal show={show} onHide={handleClose} dialogClassName="escalateModal">
        <Modal.Header closeButton>
          <Modal.Title>
            Please Provide a reason for escalting this issue
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showEscalateValidMsg ? (
            <span
              style={{
                width: '100%',
                float: 'left',
                marginTop: '5%',
                color: 'red',
                fontSize: '0.8rem',
                fontWeight: 'bold',
              }}
            >
              Please provide a reason for escalating this issue
            </span>
          ) : null}
          <CommentsInput
            onChange={setCommentMessageHandler}
            placeholder="please leave your comments here"
          />
        </Modal.Body>
        <Modal.Footer>
          <Col xs={4}>
            <SubmitIssueButtonModal
              style={{ background: '#316797' }}
              onClick={handleClose}
            >
              Cancel
            </SubmitIssueButtonModal>
          </Col>
          <Col xs={4}>
            <SubmitIssueButtonModal
              style={{ background: 'orange' }}
              onClick={updateIssueHandler.bind(this, 'Escalated')}
            >
              Confirm
            </SubmitIssueButtonModal>
          </Col>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 3%;
  margin: 5% auto;
  position: relative;
  display: flex;
  justify-content: center;
`;

const InputHeading = styled.div`
  text-align: center;
  font-size: 1rem;
  color: #d01e2d;
  width: 100%;
  padding-left: 1rem;
`;

const InputHeadingR = styled.div`
  text-align: center;
  font-size: 0.7rem;
  color: #666;
  width: 100%;
  padding-top: 6px;
  padding-right: 1rem;
`;

const StatusBanner = styled.div`
  text-align: center;
  font-size: 1rem;
  color: #fff;
  width: 100%;
  padding: 0.5rem;
  margin-top: 1rem;
`;

const ScreenshotAttached = styled.div`
  height: 100px;
  width: 100px;
  float: left;
  background-repeat: no-repeat;
  background-size: contain;
`;

const CommentsInput = styled.input`
  text-align: left;
  padding: 0.6rem;
  width: 100%;
  height: 100px;
  font-size: 0.7rem;
  color: #666;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0px 4px 15px -4px #b6b6b6;
`;

const SubmitIssueButton = styled.div`
  background: #4c8b2b;
  color: #fff;
  font-size: 1rem;
  padding: 0.7rem;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 4rem;
  text-align: center;
`;

const SubmitIssueButtonModal = styled.div`
  background: #4c8b2b;
  color: #fff;
  font-size: 0.7rem;
  padding: 0.5rem;
  border-radius: 5px;
  margin-top: 1rem;
  text-align: center;
`;
export default AdminHelpScreen;
